<template>
  <div id="userOptions">
    <!-- Authenticated User -->
    <div v-if="isAuthenticated" class="user-info">
      <img v-if="currentUser.photoURL" :src="currentUser.photoURL" alt="Profile" class="user-photo" />
      <span class="user-name">{{ currentUser.displayName || currentUser.email }}</span>
      <button
        @click="signOut"
        class="lg-btn sign-out-btn"
        :title="'Sign out ' + (currentUser.displayName || currentUser.email)"
      >Sign out</button>
    </div>

    <!-- Sign In Button -->
    <button v-else @click="handleGoogleSignIn" class="lg-btn google-signin">
      <span class="signin-full">Sign in with Google</span>
      <span class="signin-short">Sign in</span>
    </button>

    <!-- Error Message -->
    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      error: null
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated'])
  },
  methods: {
    async handleGoogleSignIn() {
      this.error = null;
      try {
        await this.$store.dispatch('signInWithGoogle');
      } catch (error) {
        this.error = 'Failed to sign in with Google. Please try again.';
        console.error('Sign in error:', error);
      }
    },
    async signOut() {
      await this.$store.dispatch('signOut');
    }
  }
};
</script>

<style lang="scss" scoped>
#userOptions {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: auto; // Push to far right
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--lgray);
  flex-shrink: 0;
}

.user-name {
  font-size: 0.9rem;
  color: var(--dark);
  font-weight: 500;
  white-space: nowrap;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sign-out-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.google-signin {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

// "Sign in with Google" full text on wide screens, shortened to just
// "Sign in" once we're hiding the avatar/name on mobile.
.signin-full  { display: inline; }
.signin-short { display: none; }

.error-message {
  color: #e74c3c;
  font-size: 0.85rem;
  margin: 0;
}

// Narrow viewports: hide the user name first, then the avatar too. At the
// smallest sizes only the Sign in/Sign out button is left - that's the
// only thing the user actually needs to act on from the header.
@media (max-width: 800px) {
  #userOptions { gap: 10px; }
  .user-name {
    max-width: 110px;
    font-size: 0.8rem;
  }
}

@media (max-width: 600px) {
  .user-name { display: none; }
  .user-photo { display: none; }

  .sign-out-btn { padding: 7px 12px; margin-left: 0; }
  .google-signin { padding: 7px 12px; }

  // Use the shorter "Sign in" label when there's no room for "with Google".
  .signin-full  { display: none; }
  .signin-short { display: inline; }
}
</style>